export default function ApplicationFieldGroup({
  legend,
  description,
  density = 'default',
  className = '',
  children,
}) {
  if (!['default', 'compact'].includes(density)) {
    throw new Error(`Unsupported ApplicationFieldGroup density: ${density}`);
  }

  const classes = [
    'av-app-field-group',
    density === 'compact' ? 'av-app-field-group--compact' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <fieldset className={classes}>
      {legend && (
        <legend className="av-app-field-group__legend">
          {legend}
        </legend>
      )}
      {description && (
        <p className="av-app-field-group__description">
          {description}
        </p>
      )}
      {children}
    </fieldset>
  );
}
